type LenisLike = {
    scrollTo?: (target: number | string | HTMLElement, options?: Record<string, unknown>) => void;
};

const ROOT_SELECTOR = "[data-go-to-top]";
const VISIBLE_CLASS = "is-visible";
const SHOW_OFFSET_PX = 240;

function getRoot(): HTMLElement | null {
    return document.querySelector<HTMLElement>(ROOT_SELECTOR);
}

function getButton(root: HTMLElement): HTMLButtonElement | null {
    return root.querySelector<HTMLButtonElement>(".no-gototop__btn");
}

function getScrollTop(): number {
    return window.scrollY ?? document.documentElement.scrollTop ?? 0;
}

function scrollToTop(): void {
    const lenis = (window as typeof window & { lenis?: LenisLike }).lenis;
    if (lenis?.scrollTo) {
        lenis.scrollTo(0, { duration: 1.1 });
        return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
}

export function initGoToTop(): void {
    const root = getRoot();
    if (!root) return;

    const button = getButton(root);
    if (!button) return;

    const updateVisibility = (): void => {
        const visible = getScrollTop() > SHOW_OFFSET_PX;
        root.hidden = !visible;
        root.classList.toggle(VISIBLE_CLASS, visible);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    button.addEventListener("click", scrollToTop);
}
